require('../../modules/es6.number.min-safe-integer');
module.exports = -0x1fffffffffffff;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/fn/number/min-safe-integer.js
// module id = 609
// module chunks = 0